// auth.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false);

  constructor() {}
  isLoggedIn(): boolean {
    return this.loggedIn.value;
  }
  getLoginStatus(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }
  setLoggedIn(status: boolean): void {
    this.loggedIn.next(status);
  }
  // isLoggedIn(): boolean {
  //   throw new Error("Method not implemented.");
  // }
  roles: any[] = [];
  // Assume you have a method to get the current user roles
  getUserRoles(): string[] {
    // Implement logic to get user roles from your authentication system
    // For example, you might fetch roles from a server or store them in a token
    // For the sake of example, returning a hardcoded array
    // return ['ADMIN', 'VENDOR','SUPER_ADMIN','USER'];
    return this.roles;
  }
  logout(): void {
    this.setLoggedIn(false);
  }
}
